import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/layout/Header';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import ServicesPage from './components/ServicesPage';
import ContactPage from './components/ContactPage';
import NeverlandPage from './components/Neverland';
import DonatePage from './components/Donate';
import FAQ from './components/FAQ';
import COTAD from './components/COTAD';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-bg-primary">
          <Header />
          
          {/* Main Content */}
          <main className="py-8">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/neverland" element={<NeverlandPage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/cotad" element={<COTAD />} />
            </Routes>
          </main>

          {/* Footer */}
          <footer className="bg-bg-secondary shadow-md mt-auto">
            <div className="container mx-auto px-4 py-6">
              <div className="text-center text-text-secondary">
                <p>&copy; {new Date().getFullYear()} Website generously donated by <a href="https://tims-tech.com" className="hover:text-primary transition-colors">Tim's Tech</a> ❤️ All right reserved.</p>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;